import React from 'react'
import { Paper, makeStyles, Grid, Typography, Box } from '@material-ui/core'
import {
  ReportProblemOutlined,
  CheckOutlined,
  ErrorOutlined,
  CloseOutlined
} from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  good: {
    color: theme.palette.success.main,
    border: `1px solid ${theme.palette.success.main}`
  },
  medium: {
    color: theme.palette.warning.main,
    border: `1px solid ${theme.palette.warning.main}`
  },
  bad: {
    color: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`
  },
  really_bad: {
    border: `1px solid ${theme.palette.grey[900]}`
  }
}))

const icon = {
  good: <CheckOutlined />,
  medium: <ReportProblemOutlined />,
  bad: <ErrorOutlined />,
  really_bad: <CloseOutlined />
}

const statusLabel = {
  good: 'Código verde',
  medium: 'Código amarelo',
  bad: 'Código vermelho',
  really_bad: 'Código preto'
}

const VisualizadorTotal = ({ title, status }) => {
  const classes = useStyles()
  return (
    <Paper className={classes[status]}>
      <Box p={2}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs="auto">
                {icon[status]}
              </Grid>
              <Grid item xs>
                <Typography color="textPrimary" variant="h6">
                  {statusLabel[status]}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto">
            <Typography color="textPrimary" variant="h6">
              {title}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  )
}

export default VisualizadorTotal
